<script>
	import Vue from 'vue'
	import {Client as ColyseusClient} from 'colyseus.js'
	import {$eBus} from '@/event-bus/index'
	import GameClientEvent from '@/enum/GameClientEvent'
	import {ConsoleLogger} from '@/console-logger'
	import AppConfig from '@/app-config'

	export default {
		name: 'game-client',
		data() {
			return {
				isConnected: false,
				client: null,
				room: null,
				roomId: null,
				logMessages: [],
				playerSessionId: false, // set in this.room.onJoin
				expanded: false,
				colyseusEndPoint: null,
				logger: new ConsoleLogger('GameClient', 'background: #00aa00; color: white', null,
					!AppConfig.debug.gameClient),
			}
		},
		mounted() {
			Object.defineProperty(Vue.prototype, '$gameClient', {
				value: this,
				configurable: true
			})

			this.logMessage(`Assigned to Vue.$gameClient`)
		},
		watch: {
			phase() {
				let newPhase = this.phase

				this.logMessage(`Phase changed! New phase: ${newPhase}`)

				$eBus.$emit(GameClientEvent.PhaseChanged, newPhase)
			},
			roomId() {
				$eBus.$emit(GameClientEvent.CustomRoomIdChanged, this.roomId)
			}
		},
		computed: {
			phase() {
				try {
					return this.room.state.phase
				} catch (error) {
					return null
				}
			}
		},
		methods: {
			isPhase(phase) {
				if (Array.isArray(phase)) {
					return phase.includes(this.phase)
				} else {
					return phase === this.phase
				}
			},

			isMe(playerId) {
				return playerId === this.playerSessionId
			},

			// Logger
			clearLog() {
				console.log('Clearing log!')

				this.logMessages = []
			},
			logMessage(message) {
				this.logger.logMessage(message)

				this.logMessages.push(message)
			},

			// Game client control
			connect(host, port, wsProtocol) {
				let colyseusHostWithPort = `${host}:${port}`

				let colyseusUrl = (wsProtocol || 'ws') + '://' + colyseusHostWithPort

				this.colyseusEndPoint = colyseusUrl

				$eBus.$emit(GameClientEvent.EndPointChanged, colyseusHostWithPort)

				this.logMessage(`Connecting to ${colyseusUrl}`)

				this.client = new ColyseusClient(colyseusUrl)

				this.client.onError.add((error) => {
					this.logMessage(GameClientEvent.Error + ': ' + error)

					$eBus.$emit(GameClientEvent.Error, this.client, error)

					this.isConnected = false
				})

				this.client.onClose.add(() => {
					this.logMessage(GameClientEvent.Close)

					$eBus.$emit(GameClientEvent.Close, this.client)

					this.isConnected = false
				})

				this.client.onOpen.add(() => {
					this.logMessage(GameClientEvent.Open)

					$eBus.$emit(GameClientEvent.Open, this.client)

					this.isConnected = true
				})
			},
			joinRoom(roomId, onJoin = null) {
				this.roomId = roomId

				this.room = this.client.join('game', {
					roomId: roomId
				})

				this.room.onJoin.add(() => {
					this.playerSessionId = this.room.sessionId

					this.logMessage(GameClientEvent.RoomJoin)

					$eBus.$emit(GameClientEvent.RoomJoin)

					if (onJoin) {
						onJoin(this.room)
					}
				})

				this.room.onError.add((error) => {
					this.logMessage(GameClientEvent.RoomError + ': ' + error)

					$eBus.$emit(GameClientEvent.RoomError, this.room, error)
				})

				this.room.onMessage.add((message) => {
					this.logMessage(GameClientEvent.RoomMessage + ': ' + message)

					$eBus.$emit(GameClientEvent.RoomMessage, this.room, message)
				})

				this.room.onLeave.add(() => {
					this.logMessage(GameClientEvent.RoomLeave)

					$eBus.$emit(GameClientEvent.RoomLeave, this.room)
				})

				this.room.onStateChange.add((state) => {
					this.logMessage(GameClientEvent.RoomStateChange)
					this.logMessage(JSON.stringify(state, null, 2))

					$eBus.$emit(GameClientEvent.RoomStateChange, this.room, state)
				})

				$eBus.$emit(GameClientEvent.RoomCreated, this.room)
			},
			leaveRoom() {
				if (this.room) {
					this.logMessage('Leaving room..')

					this.room.leave()

					this.room = null
				}
			},
			inRoom() {
				return !!this.room
			},
			send(data) {
				this.logMessage('Sending data')
				this.logMessage(JSON.stringify(data, null, 2))

				this.room.send(data)
			},
			disconnect() {
				this.logMessage('Disconnecting..')

				this.leaveRoom()
				this.closeConnection()

				this.logMessage('Disconnected!')
			},
			closeConnection() {
				if (this.client) {
					this.logMessage('Closing client connection..')

					this.client.close()

					this.client = null
				}

				this.isConnected = false
			}
		},
		render: function (h) {
			return h() // avoid warning message
		}
	}
</script>